module.exports = __webpack_public_path__ + "img/room1.f008debe.gif";